import type { ProgressRange } from '@youversion/design-system-components';

/**
 * Converts a progress value from 0-1 to ProgressRange (0-100) for design-system components.
 * @param n - Progress in 0-1 range (NaN yields 0).
 * @returns Progress as 0-100 integer (ProgressRange).
 * @example
 * toProgressRange(0.5) // 50
 * toProgressRange(0.99) // 99
 * toProgressRange(NaN) // 0
 */
export function toProgressRange(n: number): ProgressRange {
  if (Number.isNaN(n)) {
    return 0 as ProgressRange;
  }
  return Math.min(100, Math.max(0, Math.round(n * 100))) as ProgressRange;
}
